import React, { FC } from "react"
import styled from "styled-components"
import { graphql, useStaticQuery } from "gatsby"
import SearchBar from "./SearchBar"
import BasketPreview from "../basket/BasketPreview"
import MobileMenu from "../menu/MobileMenu"
import Headroom from "react-headroom"
import { darkBlue, grey, mustard } from "../../constants/colors"
import GLogo from "../../../gatsby/components/GLogo"
import { desktop, largeDesktop } from "../../constants/screenSizes"
import Menu from "../menu/Menu"
import { transformMenu } from "../../../gatsby/transformers/menuTransformer"

const Banner = styled.div`
  background-color: ${mustard};
  text-align: center;
  font-size: 0.7em;
  padding: 5px;
  letter-spacing: 2px;

  a {
    color: ${darkBlue};
    text-decoration: underline;
  }
`

const InnerHeader = styled.div`
  .headroom {
    z-index: 98 !important;
  }
  @media (max-width: $desktop) {
    width: 100%;
    background-color: white;
    z-index: 30;
  }
`
const StickyHeader = styled.div`
  z-index: 30;
  background-color: ${grey};
`
const Top = styled.div`
  background-color: $grey;
  max-width: 1200px;
  margin: auto;
  display: flex;
  align-items: center;
  height: 100px;
  justify-content: space-between;

  @media (max-width: ${desktop}) {
    height: 70px;
  }

  @media (max-width: ${largeDesktop}) {
    padding-right: 10px;
    padding-left: 10px;
  }

  @media (max-width: ${desktop}) {
    padding-left: 10px;
    padding-right: 10px;
  }
`

interface Props {
  disableHeadroom: boolean
}

const Header: FC<Props> = ({ disableHeadroom }) => {
  const data = useStaticQuery(query)
  const mainMenu = transformMenu(data.allWpMenuItem.nodes)

  const renderHeader = () => {
    return (
      <>
        {" "}
        <StickyHeader>
          <Top>
            <MobileMenu menuItems={mainMenu} />
            <GLogo />
            <SearchBar />
            <BasketPreview />
          </Top>
          <SearchBar mobile />
        </StickyHeader>
        <Menu menuItems={mainMenu} />
      </>
    )
  }
  return (
    <header>
      <InnerHeader>
        <Banner>Free shipping on UK orders over £100</Banner>
        {disableHeadroom ? renderHeader() : <Headroom pinStart={500}>{renderHeader()}</Headroom>}
      </InnerHeader>
    </header>
  )
}

const query = graphql`
  {
    allWpMenuItem(filter: { menu: { node: { slug: { eq: "main" } } } }) {
      nodes {
        id
        parentId
        label
        url
        custom {
          featuredImage {
            ...UrlImageFragment
          }
          featuredLink {
            title
            url
          }
        }
        childItems {
          nodes {
            id
            parentId
            label
            url
            childItems {
              nodes {
                id
                parentId
                label
                url
                childItems {
                  nodes {
                    id
                    parentId
                    label
                    url
                    childItems {
                      nodes {
                        id
                        parentId
                        label
                        url
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

export default Header
